<template>
  <div class="move-from-excluded-confirmation-popup">
    <popup :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:title>
        <span class="selected-category" :class="selectedCategory.cashflowCategory">להחזיר את ה{{ incomeOrExpense }} הזו לתזרים של החודש?</span>
      </template>
      <template v-slot:content>
        <div class="explanation">
          <div class="warning">זה אומר שה{{ incomeOrExpense }} הזאת <span class="bold">תופיע בחישוב התזרים של החודש!</span></div>
          <div v-if="isIncomeCategory">הכנסה שהיא חלק מחישוב התזרים היא הכנסה שהתכוונת לממן איתה את ההוצאות של החודש.</div>
          <div v-else>הוצאה שהיא חלק מחישוב התזרים היא הוצאה שהתכוונת לממן מההכנסות של אותו החודש.</div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BaseUI from 'base-ui';
import ModalBus from '../../../../../../../../../../event-bus/modal-bus';
import ChangeTransactionCategoryPopup from './ChangeTransactionCategoryPopup.vue';
import MoveFromExcludedSummaryPopup from './MoveFromExcludedSummaryPopup.vue';
import Segment from '../../../../../../../../../../Segment';

export default {
  name: 'MoveFromExcludedConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_Shown', {
      businessName: this.transaction.businessName,
      expenseCategory: this.transaction.expense,
      isIncomeCategory: this.isIncomeCategory,
      transactionId: this.transaction.transactionId,
    });
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', [
      'selectedCategory', 'originalCategory', 'ENRICHMENT_INPUT_TYPES', 'categoryToVariant', 'isIncomeCategory', 'incomeOrExpense',
    ]),
    buttonOptions() {
      return [{
        title: 'כן, להחזיר לתזרים',
        action: () => this.onSave(),
        variant: this.categoryToVariant[this.originalCategory.cashflowCategory],
      }, {
        title: 'ביטול',
        action: () => this.close(),
        variant: 'secondary-black',
      }];
    },
  },
  methods: {
    back() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_BackClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      ModalBus.$emit('open', {
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    onSave() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_AnswerClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      ModalBus.$emit('open', {
        component: MoveFromExcludedSummaryPopup,
        props: {},
      });
    },
    close() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_CloseClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .move-from-excluded-confirmation-popup {

    .explanation {
      line-height: 16px;
      white-space: pre-line;
      .warning {
        color: $riseup_coral;
        margin-bottom: 16px;
        .bold {
          font-weight: bold;
        }
      }
    }
  }

</style>
